// Показателите на „Разделени маси".
//
// Четирите числа отговарят на четири различни въпроса: колко пъти е местено,
// от колко души, каква стойност е минала между масите и колко е едно
// средно разделяне. Обхватът им е ТОЗИ на списъка отдолу — филтрите в
// колоните и търсачката ги менят заедно с таблицата, както беше и досега.

import { useTranslation } from "react-i18next";

import { fmtEuro } from "../../../../utils/currency";
import { EM_DASH } from "../../../../components/dataTable";
import { ReportKpiCard } from "../ReportKpiCard";
import type { SplitsTotals } from "./billsSplitsMath";

type Props = {
  totals: SplitsTotals;
};

export const BillsSplitsKpis = ({ totals }: Props) => {
  const { t } = useTranslation();

  return (
    // Две кутийки на ред до 1024, четири над него — прагът е чист Tailwind,
    // затова тук няма `isNarrow`: под 640 `lg:` така или иначе не важи.
    <div className="grid grid-cols-2 gap-2.5 lg:grid-cols-4">
      <ReportKpiCard
        kicker={t("reportsPage.billsSplitsSummaryTitle")}
        value={String(totals.splits)}
        sub={t("reportsPage.billsSplitsSummaryKicker")}
        hero
      />

      <ReportKpiCard
        kicker={t("reportsPage.billsSplitsWaiters")}
        value={String(totals.waiters)}
        sub={t("reportsPage.billsSplitsWaitersSub")}
      />

      <ReportKpiCard
        kicker={t("reportsPage.billsSplitsAmountTitle")}
        value={fmtEuro(totals.amount)}
        sub={t("reportsPage.billsSplitsProductsSub", {
          count: totals.products,
        })}
        hero
      />

      <ReportKpiCard
        kicker={t("reportsPage.billsSplitsAvg")}
        // Без нито едно разделяне средното не съществува — тире, не „0.00 €".
        value={totals.splits > 0 ? fmtEuro(totals.average) : EM_DASH}
        sub={t("reportsPage.billsSplitsAvgSub")}
      />
    </div>
  );
};
